import {
  GET_INVOICE_EXTRACT,
  INVOICE_EXTRACT_DATA,
  INVOICE_EXTRACT_ERROR,
  INVOICE_EXTRACT_LOADING,
} from 'store/constants'

export const initialState = {
  data: null,
  loading: true,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICE_EXTRACT:
      return { ...state, loading: true, error: null }
    case INVOICE_EXTRACT_DATA:
      const invoiceExtractListData = action?.payload?.applications?.invoiceExtract?.invoiceExtractListData || [];
      return { ...state, loading: false, data: invoiceExtractListData, error: null }
    case INVOICE_EXTRACT_ERROR:
      return { ...state, loading: false, error: action.payload }
    case INVOICE_EXTRACT_LOADING:
      return { ...state, loading: action.payload }
    default:
      return state
  }
}
